import { ArrowUp, Paperclip, Trash2 } from 'lucide-react'
import type { QueuedComposerMessage } from '@/state/useAgentStore'

export interface ComposerQueueProps {
  queuedMessages: QueuedComposerMessage[]
  onSendQueued: (id: string) => void
  onRemoveQueued: (id: string) => void
}

const ComposerQueue = ({ queuedMessages, onSendQueued, onRemoveQueued }: ComposerQueueProps) => {
  if (!queuedMessages.length) return null

  return (
    <div className='mp-agent-composer-queue'>
      <div className='mp-agent-composer-queue-header'>
        <span>
          {queuedMessages.length} message{queuedMessages.length > 1 ? 's' : ''} queued
        </span>
      </div>
      <div className='mp-agent-composer-queue-items'>
        {queuedMessages.map((item) => (
          <div key={item.id} className='mp-agent-composer-queue-item'>
            <span className='mp-agent-composer-queue-item-text'>
              {item.content}
              {item.attachments?.length ? (
                <span style={{ marginLeft: 8, opacity: 0.7, display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                  <Paperclip size={12} />
                  {item.attachments.length}
                </span>
              ) : null}
            </span>
            <div className='mp-agent-composer-queue-item-actions'>
              <button
                type='button'
                className='mp-agent-composer-queue-button'
                onClick={() => onSendQueued(item.id)}
                aria-label='Send queued message'
              >
                <ArrowUp size={12} />
              </button>
              <button
                type='button'
                className='mp-agent-composer-queue-button'
                onClick={() => onRemoveQueued(item.id)}
                aria-label='Remove queued message'
              >
                <Trash2 size={12} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ComposerQueue
